import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const SupplierContact = t.type(
  {
    id: t.string,
    supplierId: t.string,
    function: nullable(t.string),
    firstName: nullable(t.string),
    lastName: nullable(t.string),
    telephone: nullable(t.string),
    mobile: nullable(t.string),
    note: nullable(t.string),
    email: nullable(t.string),
  },
  'SupplierContact',
);

type SupplierContact = t.TypeOf<typeof SupplierContact>;
export { SupplierContact };
